<div class="landing-page-container">
  <div class="header_top flex">
    <h2 class="welcome">Welcome {{ customerUserName | uppercase }}!</h2>

    <div class="flex date_range">
      <!-- <button class="btn clearBtn" *ngIf="range.get('start')?.value && range.get('end')?.value" (click)="clearDate()">
        <lucide-icon name="X" class="lucid-icon-cross"></lucide-icon>
      </button> -->

      <label>Date Range(MM/DD/YYYY) <sup>*</sup> </label>
      <mat-form-field appearance="outline">
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-icon
          class="clearBtn"
          matDatepickerToggleIcon
          (click)="clearDate()"
          *ngIf="range.get('start')?.value && range.get('end')?.value"
          >clear</mat-icon
        >

        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="dashboard">
    <div class="chart-grid">
      <div class="chart-container">
        <div class="header">
          <h3>My Profile</h3>
          <button class="btn2" (click)="navigate('/profile-update')">Update Profile</button>
        </div>
        <highcharts-chart class="chart" [Highcharts]="pieChart" [options]="pieChartOptions"> </highcharts-chart>
      </div>
      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>My RFQ</h3>
            <button class="btn2" (click)="navigate('rfq/create-rfq')">Create RFQ</button>
          </div>
        </div>

        <div class="flex btn_detail">
          <button class="btn">
            <span class="total">{{ totalRFQ }}</span>
            <span class="label"> Total </span>
          </button>
          <button class="btn">
            <span class="returned">{{ totalReturnedRFQ }}</span>
            <span class="label"> Returned </span>
          </button>
          <button class="btn">
            <span class="inProgress">{{ totalInProgressRFQ }}</span>
            <span class="label"> In Progress </span>
          </button>
          <!-- <button class="btn">
            <span class="accepted">{{ totalAcceptedRFQ }}</span>
            <span class="label"> Accepted </span>
          </button> -->
        </div>
        <highcharts-chart class="chart" [Highcharts]="barChartRFQ" [options]="barChartOptions"> </highcharts-chart>
      </div>

      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>My Orders</h3>
            <button class="btn2" (click)="navigate('oms/orders')">View All</button>
          </div>
        </div>

        <div class="flex btn_detail">
          <button class="btn">
            <span class="total">{{ totalOMS }}</span>
            <span class="label"> Total </span>
          </button>
          <!-- <button class="btn">
            <span class="returned">{{ totaldelayedOMS }}</span>
            <span class="label"> Delayed </span>
          </button> -->
          <button class="btn">
            <span class="inProgress">{{ totalInProgressOMS }}</span>
            <span class="label"> In Progress </span>
          </button>

          <button class="btn">
            <span class="accepted">{{ totaldeliveredOMS }}</span>
            <span class="label"> Delivered </span>
          </button>
        </div>
        <highcharts-chart class="chart" [Highcharts]="barChartOMS" [options]="barChartOMSOptions"> </highcharts-chart>
      </div>
      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>My Quotes</h3>
          </div>
        </div>

        <div class="flex btn_detail">
          <button class="btn">
            <span class="total">{{ totalQuotesReceived }}</span>
            <span class="label"> Quote Received </span>
          </button>
          <button class="btn">
            <span class="returned">{{ totalQuotesAccepted }}</span>
            <span class="label"> Quote Accepted </span>
          </button>
          <!-- <button class="btn">
            <span class="inProgress">{{ 0 }}</span>
            <span class="label"> Quote Rejected </span>
          </button> -->

          <button class="btn">
            <span class="accepted">{{ totalQuotesUnderRevision }}</span>
            <span class="label"> Quote Under Revision </span>
          </button>
        </div>
        <highcharts-chart class="chart" [Highcharts]="barChartQuotes" [options]="barChartQuotesOptions"> </highcharts-chart>
      </div>

      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>My Financials</h3>
          </div>
        </div>

        <div class="svg-container">
          <img src="/assets/images/recentUpdates.svg" alt="SVG Image" />
          <h4>No Updates at the Moment</h4>
        </div>
      </div>
      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>Tasks Planner</h3>
          </div>
        </div>

        <div class="svg-container">
          <img src="/assets/images/recentUpdates.svg" alt="SVG Image" />
          <h4>No Updates at the Moment</h4>
        </div>
        <div class="line-items col-sm-12">
          <!-- <table [cellPadding]="0" [cellSpacing]="0">
            <tr>
              <th>S.No</th>
              <th>Type</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
            <tr>
              <td>1.</td>
              <td>P.O. Upload</td>
              <td>Please update you P.O.</td>
              <td><a href="">view</a></td>
            </tr>
          </table> -->
        </div>
      </div>
      <div class="chart-container">
        <div class="buttons-container">
          <div class="header">
            <h3>Latest News</h3>
          </div>
        </div>
        <div class="svg-container">
          <img src="/assets/images/recentUpdates.svg" alt="SVG Image" />
          <h4>No Updates at the Moment</h4>
        </div>
      </div>
    </div>
  </div>
</div>
